<template>
  <div class="purchase-success-view">
    <FloatingHeader title="Compra Realizada" sbtitle="" :showHeader="true" :hideSearch="true" :routeToBack="'/'">
    </FloatingHeader>

    <div class="view-content">
      <div class="view-content-icon">
        <img src="@/assets/img/success.svg" alt="Success" />
      </div>
      <div class="view-content-message">
        <h2>Aguardando pagamendo concluir</h2>
      </div>
    </div>
  </div>
</template>
<script>
import FloatingHeader from '@/components/FloatingHeader.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'PurchaseWaitingView',
  components: {
    FloatingHeader
  },
  data () {
    return {
      pix: {}
    }
  },
  computed: {
    ...mapGetters(['getPix'])
  },
  methods: {
  },
  mounted () {
    this.pix = this.getPix
  }
}
</script>
<style lang="less">
.purchase-success-view {
  position: relative;
  display: block;
  padding: 100px 20px 170px 20px;

  .view-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    margin-top: 20px;

    .view-content-icon {
      margin-bottom: 20px;

      img {
        width: 180px;
      }
    }

    .view-content-message {
      text-align: center;

      h2 {
        font-size: 24px;
        margin-bottom: 10px;
      }

      p {
        font-size: 14px;
        color: #666;
      }
    }

    .bottom-content {
      position: fixed;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      bottom: 0;
      padding: 10px 0 60px 0;

      .ticket {
        margin: 20px 0;

        span {
          font-size: 16px;
          color: #666;
          text-decoration: underline;
          color: #45A336;
        }
      }

      .view-content-button {
        button {
          display: block;
          min-width: 300px !important;
          height: 55px !important;
          margin: 5px !important;
          border: none;
          background: #45A336;
          color: white;
        }
      }
    }
  }
}
</style>
